import sum from 'lodash/sum'
import { useEffect, useCallback, Dispatch, SetStateAction } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import InputAdornment from '@mui/material/InputAdornment'
import { inputBaseClasses } from '@mui/material/InputBase'
import { formatNumber } from '../../../../../utils/general'
import { useFormState } from 'react-final-form'
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Tooltip } from '@mui/material'
import Iconify from '../../../../../components/iconify'
import { TFullResponse } from '../../../../../models'
import { getBranch } from '../../../../../redux/slices/userDropdownSlice'
import { useSelector } from 'react-redux'

// ----------------------------------------------------------------------

interface Props {
  tableData: TFullResponse[]
  handleDeleteCheck: (e: TFullResponse) => void
  setIsEdit: Dispatch<SetStateAction<boolean>>
  handleOpenAddChecksModal: any
  chartOfAccountBillData: any
}
export default function InvoiceNewEditDetails({ tableData, handleDeleteCheck, setIsEdit, handleOpenAddChecksModal, chartOfAccountBillData }: Props) {
  const { values, errors } = useFormState()
  const areRequiredFieldsFilled = values.Payment
  const branchData = useSelector(getBranch)

  const totalOnRow = values.items?.map((item: any) => item.quantity * item.price)

  const subTotal = sum(totalOnRow)

  const totalAmount = subTotal - values.discount - values.shipping + values.taxes

  //   const handleSelectService = useCallback(
  //     (index: number, option: string) => {
  //       setValue(`items[${index}].price`, INVOICE_SERVICE_OPTIONS.find((service: any) => service.name === option)?.price)
  //       setValue(`items[${index}].total`, values.items?.map((item: any) => item.quantity * item.price)[index])
  //     },
  //     [setValue, values.items],
  //   )

  const renderTotal = (
    <Stack spacing={2} alignItems='flex-end' sx={{ mt: 3, textAlign: 'right', typography: 'body2', px: 3 }}>
      <Stack direction='row' sx={{ typography: 'subtitle1' }}>
        <Box>Total</Box>
        <Box sx={{ width: 160 }}>
          $ {formatNumber(tableData?.map((item) => Number(item?.BillAmount?.toString()?.replaceAll(',', '')))?.reduce((a, b) => a + b, 0)) || '-'}
        </Box>
      </Stack>
    </Stack>
  )

  return (
    <Box sx={{ py: 3 }}>
      <Typography variant='h6' sx={{ color: 'text.disabled', mb: 3, px: 3 }}>
        Details:
      </Typography>

      <Stack spacing={3}>
        <TableContainer sx={{ overflow: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel>CoA (Bill)</TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel>Stock #</TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel>Branch</TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel>Amount</TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel>Comment</TableSortLabel>
                </TableCell>
                <TableCell align={'right'}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData?.map((item, index) => (
                <TableRow hover key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell>
                    {chartOfAccountBillData?.find((item_: any) => item_?.ChartOfAccountID === item.AccountNumberName).AccountNumber}
                  </TableCell>
                  <TableCell>{item?.StockNumber}</TableCell>
                  <TableCell>{branchData?.find((item_) => item_?.BranchID === item?.BranchCode).BranchCode}</TableCell>
                  <TableCell>${formatNumber(item?.BillAmount)}</TableCell>
                  <TableCell>{item?.Description}</TableCell>
                  <TableCell align={'right'}>
                    <Button
                      size='small'
                      color='error'
                      startIcon={<Iconify icon='solar:trash-bin-trash-bold' />}
                      onClick={() => {
                        handleDeleteCheck(item)
                        setIsEdit(true)
                      }}
                    >
                      Remove
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>

      <Divider sx={{ px: 3, my: 3, borderStyle: 'dashed' }} />

      <Stack spacing={3} sx={{ px: 3 }} direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-end', md: 'center' }}>
        <Button
          size='small'
          color='primary'
          disabled={!areRequiredFieldsFilled}
          startIcon={<Iconify icon='mingcute:add-line' />}
          onClick={handleOpenAddChecksModal}
          sx={{ flexShrink: 0 }}
        >
          Add Item
        </Button>
      </Stack>

      {renderTotal}
    </Box>
  )
}
